import { useRequest } from "../contexts/request";
import { useQuery } from "react-query";

const useWishlistDetailPublic = (slug, streamerUsername) => {
  const { get } = useRequest();
  return useQuery(
    [`wishlist-public-detail-streamer`, slug, streamerUsername],
    async (key) => {
      if (slug && streamerUsername) {
        const {
          json: { data },
        } = await get(
          `wishlist/public/${streamerUsername}/${slug}`,
        );
        return data;
      }
    },
    {
      enabled: !!slug && !!streamerUsername,
      staleTime: 0,
      retry: 1
    }
  );
};

export { useWishlistDetailPublic };
